<template>
    <div id="actions">
        
        <ul>

            <li>
                <button class="add-image" @click="openSingleImageSection">
                    Tekli Resim Ekle
                </button>
            </li>

            <li>
                <button class="add-image" @click="openMultiImageSection">
                    Çoklu Resim Ekle
                </button>
            </li>

            <li v-if="isExhibition">
                <button class="edit" @click="openExhibitionInfo">
                    Sergi Bilgilerini Düzenle
                </button>
            </li>

        </ul>

        <div id="single-image" v-if="isSingle">
            <table>
                <tbody>
                    <tr>
                        <td>Dosya seçin: </td>
                        <td><input type="file" @change="onFileSelected"></td>
                    </tr>
                    <tr>
                        <td>Eser bilgisi (EN):</td>
                        <td><textarea name="imageInfo_EN" id="imageInfo_EN" cols="50" rows="2" v-model="imageInfo_EN"></textarea></td>
                    </tr>
                    <tr>
                        <td>Eser bilgisi (TR):</td>
                        <td><textarea name="imageInfo_TR" id="imageInfo_TR" cols="50" rows="2" v-model="imageInfo_TR"></textarea></td>
                    </tr>
                    <tr>
                        <td><br></td>
                    </tr>
                    <tr>
                        <td><button @click="closeSingleSection" style="margin: auto;">Vazgeç</button></td>
                        <td><button @click="uploadSoloImage" style="margin: auto;">Yükle</button></td>
                    </tr>
                </tbody>
            </table>
            
            <!--Seçilen resimin ismi listlenir-->
            <!--Resim bilgi bölümü açılır-->
            <!--Onay alınır-->
        </div>
        <div id="multi-image" v-if="isMulti">
            <table>
                <tbody>
                    <tr>
                        <td>Dosyaları seçin: </td>
                        <td><input type="file" multiple @change="onFilesSelected"></td>
                    </tr>
                    <tr v-for="file in selectedFiles" :key="file.name">
                        <td>Dosya adı: </td>
                        <td>{{file.name}}</td>
                    </tr>
                    <tr>
                        <td><br></td>
                    </tr>
                      
                    <tr>
                        <td><button @click="closeMultiSection" style="margin: auto;">Vazgeç</button></td>
                        <td><button @click="uploadMultiImage" style="margin: auto;">Yükle</button></td>
                    </tr>
                </tbody>
            </table>

            <!--Seçilen resimlerin ismi listlenir-->
            <!--Onay alınır.-->
        </div>
        
    </div>
    
</template>

<script>
import axios from 'axios';

export default{
    props:{
        isExhibition: {
            type: Boolean,
            required: true
        }
    },

    emits: ["openExhibitionInfoModal"],
    
    data(){
        return{
            isAuthenticated: false,

            isSingle: false,
            isMulti: false,
            selectedFile: null,
            selectedFiles: null,
            imageInfo_EN: "",
            imageInfo_TR: ""
        }
    },

    methods:{
        //Toggle upload sections
        openSingleImageSection(){
            this.selectedFile = null;
            this.isMulti = false;
            this.isSingle = true;
        },
        closeSingleSection(){
            this.selectedFile = null;
            this.isSingle = false;
            this.imageInfo_EN = "";
            this.imageInfo_TR = "";
        },
        openMultiImageSection(){
            this.selectedFiles = [];
            this.isSingle = false;
            this.isMulti =  true;
        },
        closeMultiSection(){
            this.selectedFiles = [];
            this.isMulti = false;
        },


        //API calls for image upload operations
        async addSingleImageForPortfolio(){
            if (!this.selectedFile) {
                alert("Dosya seçilmedi.");
                return;
            }

            let formData = new FormData();
            formData.append("imageFile", this.selectedFile);



            try {
                const response = await axios.post("/api-path/Portfolio/add-solo-image",
                    formData,
                    {
                        headers:{
                            "Content-Type": "multipart/form-data",
                            "ImageName": this.selectedFile.name,
                            "ImageInfoEN": this.imageInfo_EN,
                            "ImageInfoTR": this.imageInfo_TR,
                            "OrderNo": "0"
                        }
                    }
                );
                console.log(response);
                if (response.status === 201) {
                    this.isSingle = false;
                    this.imageInfo_EN = "";
                    this.imageInfo_TR = "";
                    this.selectedFile = null;
                    window.location.reload();
                    alert("Eser yüklendi!");
                }
                
            } catch (error) {
                if (error.response) {
                    alert(error.response.data); // API'den dönen hata mesajını popup olarak göster
                    this.imageInfo_EN = "";
                    this.imageInfo_TR = "";
                } else {
                    alert("Sunucuya ulaşılamadı. Mert'i ara :)"); // API'ye hiç ulaşılamadıysa
                    this.imageInfo_EN = "";
                    this.imageInfo_TR = "";
                    this.selectedFile = null;
                }
            }
        },
        async addMultiImageForPortfolio(){
            if (!this.selectedFiles || this.selectedFiles.length === 0) {
                alert("Lütfen bir dosya seçin.");
                return;
            }

            let formData = new FormData();
    
            // Dosyaları FormData'ya ekle
            for (let i = 0; i < this.selectedFiles.length; i++) {
                formData.append("imageFiles", this.selectedFiles[i]);
            }

            try {
                const response = await axios.post("/api-path/Portfolio/add-multi-image", formData);

                console.log(response);
                if (response.status === 200) {
                    this.isMulti = false;
                    this.selectedFiles = [];
                    window.location.reload();
                    alert("Eser(ler) yüklendi!");
                }
            } catch (error) {
                if (error.response) {
                    alert(error.response.data); // API'den dönen hata mesajını popup olarak göster
                    alert("Aynı isme sahip görsel(ler) yüklenmeye çalışıldığı için tüm işlem başarıyla sonuçlanmadı.\n" +
                    "Sayfayı yenileyin ve hangi görsel(ler) eklenmediyse onları tekrar eklemeyi deneyin.");
                    this.selectedFiles = [];
                } else {
                    alert("Sunucuya ulaşılamadı. Mert'i ara :)"); // API'ye hiç ulaşılamadıysa
                    alert("Sayfayı yenileyin ve hangi görsel(ler) eklenmediyse onları tekrar eklemeyi deneyin.");
                    this.selectedFiles = [];
                }
            }
        },
        async addSingleImageForExhibition(){
            if (!this.selectedFile) {
                alert("Dosya seçilmedi.");
                return;
            }

            let formData = new FormData();
            formData.append("imageFile", this.selectedFile);

            try {
                const response = await axios.post("/api-path/Exhibition/add-solo-image",
                    formData,
                    {
                        headers:{
                            "Content-Type": "multipart/form-data",
                            "ImageName": this.selectedFile.name,
                            "ImageInfoEN": this.imageInfo_EN,
                            "ImageInfoTR": this.imageInfo_TR,
                            "OrderNo": "0"
                        }
                    }
                );
                console.log(response);
                if (response.status === 200) {
                    this.isSingle = false;
                    this.imageInfo_EN = "";
                    this.imageInfo_TR = "";
                    this.selectedFile = null;
                    window.location.reload();
                    alert("Eser yüklendi!");
                }
            } catch (error) {
                if (error.response) {
                    alert(error.response.data); // API'den dönen hata mesajını popup olarak göster
                    this.imageInfo_EN = "";
                    this.imageInfo_TR = "";
                } else {
                    alert("Sunucuya ulaşılamadı. Mert'i ara :)"); // API'ye hiç ulaşılamadıysa
                    this.imageInfo_EN = "";
                    this.imageInfo_TR = "";
                    this.selectedFile = null;
                }
            }
        },
        async addMultiImageForExhibition(){
            if (!this.selectedFiles || this.selectedFiles.length === 0) {
                alert("Lütfen bir dosya seçin.");
                return;
            }

            let formData = new FormData();
    
            // Dosyaları FormData'ya ekle
            for (let i = 0; i < this.selectedFiles.length; i++) {
                formData.append("imageFiles", this.selectedFiles[i]);
            }

            try {
                const response = await axios.post("/api-path/Exhibition/add-multi-image", formData);
                
                console.log(response);
                if (response.status === 200) {
                    this.isMulti = false;
                    this.selectedFiles = [];
                    window.location.reload();
                    alert("Eser(ler) yüklendi!");
                }
            } catch (error) {
                if (error.response) {
                    alert(error.response.data); // API'den dönen hata mesajını popup olarak göster
                    alert("Aynı isme sahip görsel(ler) yüklenmeye çalışıldığı için tüm işlem başarıyla sonuçlanmadı.\n" +
                    "Sayfayı yenileyin ve hangi görsel(ler) eklenmediyse onları tekrar eklemeyi deneyin.");
                    this.selectedFiles = [];
                } else {
                    alert("Sunucuya ulaşılamadı. Mert'i ara :)"); // API'ye hiç ulaşılamadıysa
                    alert("Sayfayı yenileyin ve hangi görsel(ler) eklenmediyse onları tekrar eklemeyi deneyin.");
                    this.selectedFiles = [];
                }
            }
        },


        // Select uploaded file(s)
        onFileSelected(event){
            this.selectedFile = event.target.files[0];
        },
        onFilesSelected(event){
            this.selectedFiles = event.target.files;
        },


        //Image Upload Button Methods
        uploadSoloImage(){
            if(this.isExhibition){
                this.addSingleImageForExhibition();
            }
            if(!this.isExhibition){
                this.addSingleImageForPortfolio();
            }
        },
        uploadMultiImage(){
            if(this.isExhibition){
                this.addMultiImageForExhibition();
            }
            if (!this.isExhibition) {
                this.addMultiImageForPortfolio();
            }
        },

        
        //Exhibition Info
        openExhibitionInfo(){
            this.isMulti = false;
            this.isSingle = false;
            this.$emit('openExhibitionInfoModal');
        },
    },
}

</script>

<style scoped>
#actions{
    margin-bottom: 0px;
}

#actions ul{
    display: flex;
    flex-direction: row;
    justify-content: end;
    padding-left: 0px;
}

#actions ul li{
    list-style: none;
    margin-right: 20px;
}

button{
    height: 40px;
    border-radius: 5%;
    font-size: 15px;
    border: none;
    cursor: pointer;
}

.add-image{
    background-color: #218838;
    color: aliceblue;
}

.edit{
    background-color: #E0A800;
}

#single-image{
    margin-bottom: 10px;
    
    
}

#multi-image{
    margin-bottom: 10px;
}

table{
    margin: auto;
    background-color: rgb(170, 170, 170);
    border-radius: 1%;
}
</style>